// extracted by mini-css-extract-plugin
export default {"logoutButton":"IysFthpSMkQpY3kx37xtk","logoutButtononboard":"oxkJuy8WcYOICo0Fj12-I","logoutButtonInline":"_3td1SdN6iT8UNbimkt-5mU"};